//Import React Hooks
import { useEffect, useState } from 'react'

//MUI :
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Popover from '@mui/material/Popover';

//Import created components
import CreneauPopover from '../../components/creneaupopover/CreneauPopover.jsx'


//selectors for redux :
import { useSelector, useDispatch } from "react-redux";

//Translate utils :
import { translator } from "../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

function AddSession({ eleve, nbcours }) {

    const lang = useSelector(getLang) //global state : language


    function customTexte() {
        let caption = "Ajouter une session";
        if (nbcours > 2) { caption = "Session" }
        if (nbcours >= 5) { caption = "" }
        return caption;
    }

    //// ----- popover management
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        //console.log(anchorEl)
    };
    const open = Boolean(anchorEl);
    const id = open ? 'popover-add' : undefined;
    //// -- end of popover mgmt

    return (

        <div className="add-session">

            {nbcours >= 5 ? null : <Button variant="contained" size="small" onClick={handleClick}> <AddIcon /><p>{translator("Ajouter une session", lang, "calendarAddSession")}</p></Button>}

            <Popover
                className="creneau-popover-root"
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <CreneauPopover creneau={{ id_creneau: 0 }} setAnchorEl={setAnchorEl} mode={"ajout"} eleve={eleve} />
            </Popover>
        </div>
    );
}

export default AddSession;